import { Box } from '@mui/material';
import { FormikProps } from 'formik';
import RowOfStatement from './RowOfStatement';
import IbanField from './IbanField';
import { IBAN_PLACEHOLDER } from '../helpers/iban';
import { FormValues } from '../FormPagePerson';

// Rachunek do wypłaty wynagrodzenia. Sekcja niezależna od oświadczeń ZUS —
// jest potrzebna zawsze, niezależnie od ZUS_STATEMENTS_ENABLED.
const SettlementData = ({ formik }: { formik: FormikProps<FormValues> }) => (
    <RowOfStatement
        formik={formik}
        title={
            // Dwie etykiety w lewej kolumnie — odstęp odpowiada wysokości pola IBAN,
            // żeby "Nazwa banku" wypadła na wysokości drugiego pola.
            <>
                <span>Numer konta (IBAN)</span>
                <Box component="span" sx={{ display: 'block', marginTop: '56px' }}>
                    Nazwa banku
                </Box>
            </>
        }
        name="accountNumber"
        input={
            <IbanField
                sx={{ maxWidth: 600 }}
                value={formik.values.accountNumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder={IBAN_PLACEHOLDER}
                bankName={formik.values.bankName}
                setBankName={(v) => formik.setFieldValue('bankName', v)}
                setValue={(v) => formik.setFieldValue('accountNumber', v)}
                error={formik.touched.accountNumber && Boolean(formik.errors.accountNumber)}
                helperText={formik.touched.accountNumber && formik.errors.accountNumber}
            />
        }
    />
);

export default SettlementData;
